import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import FormActions from '../../../components/form/FormActions.tsx';
import Table from '../../../components/Table.tsx';
import { useRecipesContext } from '../../../contexts/recipes/recipes.tsx';

const RecipesBody = () => {
    const { recipes, deleteRecipe } = useRecipesContext();
    const navigate = useNavigate();
    const columns = [
        {
            header: "name",
            name: "name",
            enableSorting: true,
            cell: (props: any) => {
                const { recipeID, name } = props.row;
                return (
                    <Link className="nav-link" to={`/recipes/${recipeID}`}>
                        <span >{name}</span>
                    </Link>
                );
            }
        },
        {
            header: "published",
            name: "isPublished",
            enableSorting: false,
        },
        {
            header: "validated",
            name: "isValidated",
            enableSorting: false,
        },
        {
            header: "",
            name: "delete",
            actionHandler: (props: any) => {
                const { recipeID } = props.row;
                return deleteRecipe(recipeID);
            },
            enableSorting: false
        }
    ]

    return (
        <>
            <Table columns={columns} rows={recipes} />
            <FormActions
                mainAction={() => { navigate("/recipes/create"); }}
                mainActionText="Create"
            />
        </>
    );
};

export default RecipesBody;